import { motion } from "framer-motion";
import { AVATAR_URL } from "@/components/avatar";

export const MessageBubble = ({ role, content }) => {
  const isUser = role === "user";
  return (
    <motion.div
      data-testid={`message-${role}`}
      initial={{ opacity: 0, y: 10, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: "spring", bounce: 0.3, duration: 0.5 }}
      className={`flex items-end gap-2.5 ${isUser ? "justify-end" : "justify-start"}`}
    >
      {!isUser && (
        <img
          src={AVATAR_URL}
          alt="Thamelnesan"
          className="h-9 w-9 rounded-full object-cover border-2 border-[#0cb0b5]/50 shrink-0"
        />
      )}
      <div
        className={
          isUser
            ? "bg-[#0cb0b5] text-white rounded-2xl rounded-br-sm px-5 py-3 max-w-[80%] text-[15px] leading-relaxed shadow-[0_4px_18px_rgba(12,176,181,0.28)]"
            : "bg-[#121b29] border border-[#1e293b] rounded-2xl rounded-bl-sm text-slate-100 px-5 py-3 max-w-[85%] text-[15px] leading-relaxed whitespace-pre-wrap shadow-sm"
        }
      >
        {content}
      </div>
    </motion.div>
  );
};
